var spoiler_default = {
  "fontElementMap": "bSnfS",
  "hideText": "Xw3ge",
  "onHoverText": "f-O58",
  "hideBlock": "_9Flc-",
  "smallBlur": "skE0H",
  "mediumBlur": "z5714",
  "largeBlur": "eA6J8",
  "hideBlock_gallery": "URWmy",
  "overlay": "GXGcL",
  "overlay_gallery": "caVGy",
  "revealSpoilerBtn": "QzuNb",
  "isMobile": "mw8wG",
  "onHoverBtn": "YVvAV",
  "spoilerWrapper": "lAiks",
  "spoilerDescription": "FoDIh",
  "spoilerContainer": "p2oM0",
  "spoilerContainer_Gallery": "I7AfQ"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
